export enum LocalStorageKeys {
  NEW_TASK_DRAFT = 'newTaskDraft',
  TIMELINE_FILTERS = 'timelineFilters',
  THEME = 'theme',
  DARK_STYLE = 'darkStyle',
  SIDEBAR_COLLAPSED = 'sidebarCollapsed',
  NARROW_NAV_STYLE = 'narrowNavStyle'
}
